import { OptionDto } from "@/dtos";

const limitMinutes = [
    { value: undefined, label: 'Todos' },
    { value: 1, label: '1 minuto' },
    { value: 5, label: '5 minutos' },
    { value: 10, label: '10 minutos' },
] as OptionDto[];

export const getTrackingLimitMinutesOptions = (): OptionDto[] => {
    return limitMinutes;
}

export const getTrackingLimitMinutesOption = (value?: number): OptionDto => {
    return limitMinutes.find((x) => x.value == value) ?? limitMinutes[0];
}